"use strict";

var _defineProperty2 = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _slicedToArray = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _toConsumableArray = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/toConsumableArray.js").default;
var _classCallCheck = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createClass.js").default;
var _assertThisInitialized = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/assertThisInitialized.js").default;
var _inherits = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/inherits.js").default;
var _createSuper = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/createSuper.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSSInlineParseRun = void 0;
var _cssToReactNative = require("css-to-react-native");
var _CSSParseRun = require("./CSSParseRun");
var _ShortMergeRequest = require("./ShortMergeRequest");
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var CSSInlineParseRun = /*#__PURE__*/function (_CSSParseRun$CSSParse) {
  _inherits(CSSInlineParseRun, _CSSParseRun$CSSParse);
  var _super = _createSuper(CSSInlineParseRun);
  function CSSInlineParseRun(inlineCSS, registry) {
    var _this;
    _classCallCheck(this, CSSInlineParseRun);
    _this = _super.call(this, registry);
    _defineProperty(_assertThisInitialized(_this), "rules", void 0);
    _this.rules = _this.parseInlineCSS(inlineCSS);
    _this.normalizeProp = _this.normalizeProp.bind(_assertThisInitialized(_this));
    _this.reduceProps = _this.reduceProps.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(CSSInlineParseRun, [{
    key: "parseInlineCSS",
    value: function parseInlineCSS(inlineCSS) {
      return inlineCSS.split(';').map(function (prop) {
        return prop.split(':');
      }).reduce(function (acc, prop) {
        if (prop.length === 2) {
          return [].concat(_toConsumableArray(acc), [[prop[0].trim(), prop[1].trim()]]);
        }
        return acc;
      }, []);
    }
  }, {
    key: "normalizeProp",
    value: function normalizeProp(rule) {
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var rawName = rule[0];
      var rawValue = rule[1];
      var camelCaseName = (0, _cssToReactNative.getPropertyName)(rawName);
      if (!this.validationMap.shouldRegisterInlineProperty(camelCaseName)) {
        return null;
      }
      var validator = this.validationMap.getValidatorForProperty(camelCaseName);
      var normalizedValue = validator.normalizeInlineCSSValue(rawValue);
      if (normalizedValue === null) {
        if (strict) {
          throw new TypeError();
        }
        return null;
      }
      return [camelCaseName, normalizedValue];
    }
  }, {
    key: "reduceProps",
    value: function reduceProps(reg, rule) {
      var _this2 = this;
      if (!rule) {
        return reg;
      }
      var _rule = _slicedToArray(rule, 2),
        camelCaseName = _rule[0],
        normalizedValue = _rule[1];
      if (normalizedValue instanceof _ShortMergeRequest.ShortMergeRequest) {
        try {
          return normalizedValue.map(function (r) {
            return _this2.normalizeProp(r, true);
          }).reduce(this.reduceProps, reg);
        } catch (e) {
          return reg;
        }
      }
      return _objectSpread(_objectSpread({}, reg), {}, _defineProperty2({}, camelCaseName, normalizedValue));
    }
  }, {
    key: "fillProcessedProps",
    value: function fillProcessedProps() {
      var _this3 = this;
      var rawTransformed = this.rules.map(function (r) {
        return _this3.normalizeProp(r);
      }).reduce(this.reduceProps, {});
      Object.keys(rawTransformed).forEach(function (camelCaseName) {
        var value = rawTransformed[camelCaseName];
        var validator = _this3.validationMap.getValidatorForProperty(camelCaseName);
        var normalizedValue = validator.normalizeInlineCSSValue(value);
        _this3.processedProps.withProperty(camelCaseName, normalizedValue, validator);
      });
    }
  }]);
  return CSSInlineParseRun;
}(_CSSParseRun.CSSParseRun);
exports.CSSInlineParseRun = CSSInlineParseRun;